export default __webpack_public_path__ + "static/defiant-65c68c8fc68089b11a6696c97d3a3482.png";